window.updateDeliveryNoteTime = function updateDeliveryNoteTime() {
    const now = new Date();
    const dayOfWeek = now.getDay();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    let delivery_day = 'Morgen';
    let delivery_text = 'Wenn Sie jetzt bestellen';
    const targetTime = new Date();
    targetTime.setHours(12, 30, 0, 0);
    const timeRemaining = targetTime - now;
    const hoursRemaining = Math.floor(timeRemaining / (1000 * 60 * 60));
    const minutesRemaining = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));

    if (dayOfWeek === 6 || dayOfWeek === 0 || (dayOfWeek === 5 && (hours === 12 && minutes >= 30 || hours > 12))) {
        delivery_day = 'Dienstag';
    } else if (dayOfWeek <= 5 && (hours === 12 && minutes < 30 || hours < 12)) {
        delivery_text = 'Bei Bestellung innerhalb von ' + hoursRemaining + ' Stunde(n) und ' + minutesRemaining + ' Minuten';
    } else {
        const date = new Date();
        date.setDate(date.getDate() + 2);
        delivery_day = date.toLocaleDateString('de-DE', { weekday: 'long' });
    }

    const html = '<b>Kostenlose Express-Lieferung: ' + delivery_day + '</b> - ' + delivery_text + '.';
    const countdownTargets = [
        document.getElementById('delivery-countdown'),
        document.getElementById('cart-drwer-delivery-countdown')
    ];

    countdownTargets.forEach((target) => {
        if (target) target.innerHTML = html;
    });

    if (window.__deliveryNoteTimer) clearTimeout(window.__deliveryNoteTimer);
    window.__deliveryNoteTimer = setTimeout(window.updateDeliveryNoteTime, 60000);
};

document.addEventListener('DOMContentLoaded', function () {
    window.updateDeliveryNoteTime();
});